//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheCurtains from "../components/TheCurtains";
import TheImageLog from "../components/TheImageLog";

import { mapState } from "vuex";

export default {
  data: function () {
    return {
      types: []
    };
  },

  components: {
    TheCurtains,
    TheImageLog,
  },

  computed: {
    ...mapState({
      logQuantityJSON: state => state.drilling.logQuantityJSON,
      showImageLog: state => state.preferences.showImageLog,
    }),
    selectedLogQuantities: {
      get() {
        return this.$store.state.logs.selectedLogQuantities;
      },
      set(value) {
        this.$store.commit("logs/updateSelectedLogQuantities", value);
      }
    },
    defaultInstrumentOffset: {
      get() {
        return this.$store.state.drilling.defaultInstrumentOffset
      },
      set(value) {
        this.$store.commit("drilling/updateDefaultInstrumentOffset", value);
      }
    },
    logQuantityTree() {
      const children = this.types.map(type => ({
        id: type,
        name: this.getName(type),
        children: this.getChildren(type)
      }));

      return [
        {
          id: 1,
          name: "All Logs",
          children
        }
      ];
    },

  },

  watch: {
    logQuantityJSON: {
      immediate: true,
      handler(val, oldVal) {
        this.types = val
          .reduce((acc, cur) => {
            const type = cur.sourceType;

            if (!acc.includes(type)) acc.push(type);

            return acc;
          }, [])
          .sort();
      }
    }
  },

  methods: {
    getChildren(type) {
      const logChildren = [];

      for (const logQuantityNode of this.logQuantityJSON) {
        if (logQuantityNode.sourceType !== type) continue;

        logChildren.push({
          ...logQuantityNode,
          name: this.getName(logQuantityNode.name)
        });
      }

      return logChildren.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
    },
    getName(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
    }
  }
};
